var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('b-alert',{staticClass:"thank-you-message mt-4",attrs:{"variant":"success","show":""}},[_vm._v("\n    "+_vm._s(_vm.message)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }